import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ImageModule } from 'primeng/image';
@Component({
  selector: 'app-admin-submenu',
  standalone: true,
  imports: [ImageModule, CommonModule,RouterLink, RouterLinkActive,],
  templateUrl: './admin-submenu.component.html',
  styleUrl: './admin-submenu.component.scss'
})
export class AdminSubmenuComponent {
  menuItems = [
    {
      title: 'Productos & Servicios',
      class: 'pi pi-dollar text-4xl text-green-500',
      description:'Gestiona productos y servicios que se ofrecen en la Escuela',
      routerLink: 'productos-servicios'
    },
    {
      title: 'Niveles & Categorías',
      class: 'pi pi-sitemap text-4xl text-blue-500',
      description:'Configura los niveles y categorías de los productos y servicios',
      routerLink: 'niveles-categorias'
    },
    {
      title: 'Gestión Masiva de Miembros',
      class: 'pi pi-users text-4xl text-red-500',
      description:'Administra masivamente el estado de los miembros de todos los clubes',
      routerLink: 'bulk-members'
    },
  ]
}
